import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, GasoilConsumptionPriceSource } from "__generated__/graphql";

export const SupplementaryHeatingSchema: RegistryItem = {
	[AgreementTypeEnum.SupplementaryHeating]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.GasoilConsumption,
				priceSource: GasoilConsumptionPriceSource.Manual,
			},
		},
		agreementFields: {
			"agreement.costType": { rules: { hidden: true } },
			"agreement.description": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
		},
	},
};
